// extracted by mini-css-extract-plugin
module.exports = {"root":"junk-removal-page_root__C8By2"};